<template>
	<div style="margin-bottom: 40px;">
		<el-table :data="yjzy.data" class="tableEl"  :header-row-style="{
			backgroundImage:`url(${headerBg})`,
			backgroundRepeat: 'no-repeat',
			backgroundSize: '100% 100%',
			color:'#000'
		}" :header-cell-style="{
			background:'none'
		}" :border="false">
			<el-table-column :prop="item.value" :label="item.label"  v-for="(item,index) in yjzy.head" :key="index"  min-width="100">
			</el-table-column>
		</el-table>
		<div class="yjzydw" v-if="yjzy.dw">
			{{yjzy.dw}}
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props:{
			yjzy:{
				typeof:Object,
				default:''
			}
		},
		data() {
			return {
				
				headerBg:require("@/assets/about/tzzgx/bj.png")
			}
		},
		mounted() {
			console.log(this.yjzy)
		},
		methods: {
			
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.yjzydw{
		font-size: 20px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #B6B6B6;
		margin-top: 21px;
		text-align: right;
	}
	.tableEl{
		width: 100%;
	}
	@media screen and (max-width:1200px) {
		::v-deep{
			.el-table {
				tr{
					background-color: transparent !important;
				}
			}
		} 
		.tableEl{
			width: 100vw !important;
		}
		.yjzydw{
			font-size: 12px !important;
		}
		
	}
</style>